var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.currentUser && _vm.currentUser.id
    ? _c(
        "el-button",
        {
          staticStyle: { width: "100%" },
          attrs: {
            title:
              JSON.stringify(_vm.currentUser) +
              " 点我干啥呢? 切换用户? 重新登陆?",
            plain: ""
          },
          on: { click: _vm.goLogin }
        },
        [
          _vm._v(
            "#" +
              _vm._s(_vm.currentUser.id) +
              " " +
              _vm._s(_vm.currentUser.name) +
              "(" +
              _vm._s(_vm.currentUser.loginName) +
              "," +
              _vm._s(_vm.currentUser.phone) +
              ") 已登陆"
          )
        ]
      )
    : _c(
        "el-button",
        {
          staticStyle: { width: "100%" },
          attrs: { title: "点我干啥呢? 切换用户? 重新登陆?", plain: "" },
          on: { click: _vm.goLogin }
        },
        [_vm._v(_vm._s("new" != this.dataMode ? "未登陆" : "点我去登陆"))]
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fb6204a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fb6204a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketFormAuth.vue
// module id = 938
// module chunks = 75